module.exports = __webpack_public_path__ + "img/dog-hd.2fa8044f.png";